"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KlineWebSocket = void 0;
const rxjs_1 = require("rxjs");
const CacheData_1 = require("./base/CacheData");
const SubsPairMgr_1 = require("./base/SubsPairMgr");
const BaseWebSocket_1 = require("./BaseWebSocket");
const QuotationSocketMgr_1 = require("./QuotationSocketMgr");
class KlineWebSocket extends BaseWebSocket_1.BaseWebSocket {
    constructor() {
        super(...arguments);
        this.klineCacheData = new CacheData_1.CacheData([], new rxjs_1.Subject());
        this.klinePairPoolMgr = new SubsPairMgr_1.SubsPairMgr(QuotationSocketMgr_1.SubscribeEventType.kline, (type, param) => {
            return this.send(QuotationSocketMgr_1.SubscribeEventType.kline, param);
        });
    }
    handleKlineData(pushData) {
        if (!pushData || !pushData.length) {
            return;
        }
        const klines = pushData;
        if (!klines) {
            return;
        }
        this.klineCacheData.getDataSubject().next(klines);
    }
    /**
     * @param exchange
     * @param base
     * @param quote
     */
    getKlineObservable(exchange, base, quote, interval) {
        this.klinePairPoolMgr.addSubscribePair([{ market: exchange, base: base, quote: quote, interval: interval }]);
        return new rxjs_1.Observable((observer) => {
            const subscription = this.klineCacheData.getDataSubject().subscribe((result) => {
                if (result && result.length) {
                    const item = result[0];
                    if (item.e === exchange && item.b === base && item.q === quote && item.i === interval) {
                        observer.next(result);
                    }
                }
            }, (err) => { });
            observer.add(() => {
                subscription.unsubscribe();
                this.klinePairPoolMgr.removeSubscribePair([
                    {
                        market: exchange,
                        base: base,
                        quote: quote,
                        interval: interval,
                    },
                ]);
            });
        });
    }
}
exports.KlineWebSocket = KlineWebSocket;
